export default (name: string) => {
  const names = name?.split(' ');
  const firstLetter = (string: string) => string.substring(0, 1).toUpperCase();
  return names?.splice(0, 2).map(firstLetter).join('');
};
